<ng-container [formGroup]="patientForm">
    <p-fieldset>
        <ng-template pTemplate="header">
            BASIC INFORMATION
            <ng-container *ngIf="patientForm.get('miProNumber').value">
                - ORB Number: <m-copy-value [value]="patientForm.get('miProNumber').value"></m-copy-value>
            </ng-container>
        </ng-template>
        <div class="grid p-fluid">
            <div class="col-6">
                <m-control-group [required]="true" label="Title">
                    <m-title-control formControlName="title" (onBlur)="_onBlur()"></m-title-control>
                    <control-errors [control]="patientForm.get('title')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="First Name">
                    <m-text-control [readonly]="isConnectedToNHS" formControlName="firstName" (onClick)="showReadonlyFieldsWarning()"></m-text-control>
                    <control-errors [control]="patientForm.get('firstName')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="Last Name">
                    <m-text-control [readonly]="isConnectedToNHS" formControlName="lastName" (onClick)="showReadonlyFieldsWarning()"></m-text-control>
                    <control-errors [control]="patientForm.get('lastName')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="Date of Birth">
                    <!-- We cannot disable the calendar button of the p-calendar, so we need to use a normal input to make the field readonly-->
                    <m-dob-control *ngIf="!isConnectedToNHS" formControlName="dateOfBirth"></m-dob-control>
                    <input *ngIf="isConnectedToNHS" [value]="dateOfBirthAsString" type="text" readonly="true" pInputText (click)="showReadonlyFieldsWarning()"/>
                    <control-errors [control]="patientForm.get('dateOfBirth')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="Sex">
                    <m-gender-control formControlName="gender" (onBlur)="_onBlur()"></m-gender-control>
                    <control-errors [control]="patientForm.get('gender')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group label="Phone No.">
                    <m-text-control formControlName="phoneNumber" (onBlur)="_onBlur()"></m-text-control>
                    <control-errors
                        [control]="patientForm.get('phoneNumber')"
                        [errors]="{ pattern: 'The phone number is invalid' }"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group label="NHS Number">
                    <m-text-control formControlName="nhsNumber" (onBlur)="_onBlur()"></m-text-control>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="requiredEmail" label="Email Address">
                    <m-email-control formControlName="email" (onBlur)="_onBlur()">
                        <ng-container *ngIf="actualEmailAddress.length > 0">
                            <button
                                doNotPropagateClick
                                pButton
                                pRipple
                                type="button"
                                icon="pi pi-info-circle"
                                class="p-button-secondary p-button-rounded p-button-text"
                                (click)="temporaryEmailInfo.toggle($event)"></button>
                            <p-overlayPanel #temporaryEmailInfo appendTo="body">
                                <div>
                                    <p>This email address is temporary, whilst waiting for the Patient to confirm the change to the email address.</p>
                                    <p>The actual email address of this Patient, used for login purposes, is: <b>{{actualEmailAddress}}</b></p>
                                </div>
                            </p-overlayPanel>
                        </ng-container>
                    </m-email-control>
                    <control-errors
                        [control]="patientForm.get('email')"
                        [errors]="{
                            pattern: 'The email is invalid',
                            emailMaxLength: 'The email cannot exceed {emailMaxLength} characters'
                        }"></control-errors>
                        <small *ngIf="patientForm.get('nhsNumber').value !== null" style="
                            color: red;
                            font-family: 'Arial', 'Helvetica', sans-serif;
                            font-style: italic;">
                            Changing your email will not update your NHS account.
                        </small>
                </m-control-group>
            </div>
        </div>
    </p-fieldset>

    <p-fieldset legend="ADDRESS DETAILS">
        <div class="grid p-fluid">
            <div class="col-6">
                <m-control-group [required]="selfRegister" label="Address Line 1">
                    <m-text-control formControlName="addressLine1" (onBlur)="_onBlur()"></m-text-control>
                    <control-errors [control]="patientForm.get('addressLine1')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="selfRegister" label="Address Line 2">
                    <m-text-control formControlName="addressLine2" (onBlur)="_onBlur()"></m-text-control>
                    <control-errors [control]="patientForm.get('addressLine2')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group label="Address Line 3">
                    <m-text-control formControlName="addressLine3" (onBlur)="_onBlur()"></m-text-control>
                    <control-errors [control]="patientForm.get('addressLine3')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group label="Address Line 4">
                    <m-text-control formControlName="addressLine4" (onBlur)="_onBlur()"></m-text-control>
                    <control-errors [control]="patientForm.get('addressLine4')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="selfRegister" label="Post Code">
                    <m-text-control formControlName="postcode" (onBlur)="_onBlur()"></m-text-control>
                    <control-errors [control]="patientForm.get('postcode')"></control-errors>
                </m-control-group>
            </div>
        </div>
    </p-fieldset>
</ng-container>

<p-fieldset *ngIf="showOtherInformation" legend="OTHER INFORMATION">
    <div class="grid p-fluid">
        <ng-content></ng-content>
    </div>
</p-fieldset>
